import { queryOptions } from "@tanstack/react-query";
import { apiFetch, qs } from "./client";
import type {
  FreshnessResponse,
  MeResponse,
  Metric,
  Period,
  Scope,
  ScopeCountResponse,
  TabId,
  TabResponseMap,
  TeamsResponse,
} from "./types";

/** queryOptions() gives us one typed source of truth per endpoint —
 * hooks reuse these instead of redeclaring keys + fetchers inline. */

export const authMeQuery = () =>
  queryOptions({
    queryKey: ["auth", "me"] as const,
    queryFn: () => apiFetch<MeResponse>("/api/auth/me"),
    retry: false,
    staleTime: 60 * 1000,
  });

export const freshnessQuery = () =>
  queryOptions({
    queryKey: ["filters", "freshness"] as const,
    queryFn: () => apiFetch<FreshnessResponse>("/api/filters/freshness"),
  });

export const scopeCountQuery = (scope: Exclude<Scope, "all">) =>
  queryOptions({
    queryKey: ["filters", "scope-count", scope] as const,
    queryFn: () =>
      apiFetch<ScopeCountResponse>(`/api/filters/scope-count${qs({ scope })}`),
  });

export const teamsQuery = () =>
  queryOptions({
    queryKey: ["teams"] as const,
    queryFn: () => apiFetch<TeamsResponse>("/api/teams"),
  });

export interface TabFilters {
  period: Period;
  metric: Metric;
  scope: Scope;
}

export const tabQuery = <K extends TabId>(tabId: K, filters: TabFilters) =>
  queryOptions({
    queryKey: ["tab", tabId, filters] as const,
    queryFn: () =>
      apiFetch<TabResponseMap[K]>(
        `/api/tabs/${tabId}${qs({
          period: filters.period,
          metric: filters.metric,
          scope: filters.scope,
        })}`,
      ),
  });
